import React, { useEffect, useRef } from 'react';
import { Check, Minus } from 'lucide-react';

import { cn } from '../../utils/cn';

export type CapSelectionCheckboxProps = {
  checked?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent) => void;
  'aria-label'?: string;
};

export function CapSelectionCheckbox({
  checked = false,
  indeterminate = false,
  disabled = false,
  onChange,
  onClick,
  'aria-label': ariaLabel,
}: CapSelectionCheckboxProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const showCheck = checked && !indeterminate;
  const showMinus = indeterminate;

  return (
    <label
      className={cn(
        'cap-sel-check',
        showCheck && 'is-checked',
        showMinus && 'is-indeterminate',
        disabled && 'is-disabled'
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        ref={inputRef}
        type="checkbox"
        className="cap-sel-check__input"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        onClick={onClick}
        aria-label={ariaLabel}
      />
      <span className="cap-sel-check__box" aria-hidden>
        {showCheck ? <Check size={14} strokeWidth={3} /> : null}
        {showMinus ? <Minus size={14} strokeWidth={3} /> : null}
      </span>
    </label>
  );
}

export default CapSelectionCheckbox;
